module.exports = __webpack_public_path__ + "static/pie3-1bbb8562e022f3fe47c1d00782c04d93.png";